import type { models } from 'cesg-shared';
import { fortnoxHttpService } from '../standard/http-service';

class SyncService {
  async getStatus(): Promise<models.GetSyncStatusResponse[]> {
    const status = await fortnoxHttpService.request
      .url(`/sync/status`)
      .get()
      .json<models.GetSyncStatusResponse[]>();
    return status;
  }

  async syncResource(resource: string): Promise<void> {
    await fortnoxHttpService.request.url(`/sync/${resource}`).put().res();
  }

  async syncFortnoxInvoiceFiles(): Promise<void> {
    await fortnoxHttpService.request
      .url(`/sync/fortnox-invoice-files`)
      .post()
      .res();
  }
}

export const syncService = new SyncService();
